// extracted by mini-css-extract-plugin
export var cartContainer = "styles-module--cartContainer--3s5pe";
export var cartSummaryContainer = "styles-module--cartSummaryContainer--3NeRe";
export var cartItemsContainer = "styles-module--cartItemsContainer--3wpEH";
export var cartItem = "styles-module--cartItem--2LY_H";
export var cartTotal = "styles-module--cartTotal--2MHTm";
export var cartNotes = "styles-module--cartNotes--6gDPZ";
export var checkoutButton = "styles-module--checkoutButton--3Enyp";